import React, { useState } from "react";
import "./actorDetails.css";

const YoutubeCard = ({ videoLink, onClick }) => {


  return (
    <div className="yt-card">
        <iframe
          className="yt-playing"
          src={videoLink}
          title="YouTube video player"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        ></iframe>
        
    </div>
  );
};

export default YoutubeCard;
